import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
// Styles are inlined since these components will be rendered for PDF generation
export const TableView = ({ data, columns }) => {
    // else Typescript will complain about the type of value
    const isRenderable = (value) => typeof value === 'string' ||
        typeof value === 'number' ||
        typeof value === 'boolean' ||
        (typeof value === 'object' && React.isValidElement(value)) ||
        Array.isArray(value);
    return (_jsxs("table", { style: { width: '100%', color: 'rgba(17, 24, 39, 0.60)', borderCollapse: 'collapse' }, children: [_jsx("thead", { children: _jsx("tr", { children: columns.map((column) => (_jsx("th", { style: { textAlign: 'left', padding: '16px 24px', fontSize: '12px', fontWeight: '500' }, children: column.label }, column.key))) }) }), _jsx("tbody", { children: data.map((row, rowIndex) => (
                // eslint-disable-next-line react/no-array-index-key
                _jsx("tr", { style: { borderBottom: '1px solid #E5E7EB' }, children: columns.map((column) => {
                        const value = row[column.key];
                        return (_jsx("td", { style: {
                                padding: '16px 24px',
                                fontSize: '14px',
                                fontStyle: 'normal',
                                fontWeight: 400,
                                textAlign: 'left',
                            }, children: isRenderable(value) ? (column.render ? column.render(value) : value) : '' }, column.key));
                    }) }, `row${rowIndex}`))) })] }));
};
//# sourceMappingURL=table_view.component.js.map